<ng-container *transloco="let t">
  <ul class="nscp-download-app-step__usp-list">
    @for (usp of usps; track usp.titleKey) {
      <li class="nscp-download-app-step__usp">
        <sds-icon class="nscp-download-app-step__usp-icon" filled name="sdsCheckCircle" />
        <div class="nscp-download-app-step__usp-text">
          <p class="nscp-download-app-step__usp-title">{{ t(usp.titleKey) }}</p>
          <p class="nscp-download-app-step__usp-description">{{ t(usp.descriptionKey) }}</p>
        </div>
      </li>
    }
  </ul>

  <div class="nscp-download-app-step__stores">
    <div class="nscp-download-app-step__qr-codes">
      <img class="nscp-download-app-step__qr-code" src="/assets/images/onboarding/qr-code-app-store.svg" alt="QR-code App Store" />
      <img class="nscp-download-app-step__qr-code" src="/assets/images/onboarding/qr-code-google-play.svg" alt="QR-code Google Play Store" />
    </div>

    <div class="nscp-download-app-step__badges">
      <a ngpFocusVisible [href]="appStoreUrl" target="_blank" metricId="onboarding.downloadApp.app-store-badge">
        <img class="nscp-download-app-step__badge" src="/assets/images/onboarding/app-store-badge-nl.svg" alt="Download in de App Store" />
      </a>
      <a ngpFocusVisible [href]="googlePlayUrl" target="_blank" metricId="onboarding.downloadApp.google-play-badge">
        <img class="nscp-download-app-step__badge" src="/assets/images/onboarding/google-play-badge-nl.svg" alt="Download in de Google Play Store" />
      </a>
    </div>
  </div>
</ng-container>
